module.exports = __webpack_public_path__ + "img/banner.fbfdbcd4.jpg";